import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AuthService } from '../auth-service/auth.service';
import { inject } from '@angular/core';
import { Roles } from '../../constants/menu-item';
import { LicenseService } from '../license/license.service';

export const authGuard: CanActivateFn = async (route, state): Promise<boolean | UrlTree> => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const licenseService = inject(LicenseService);

  // Verify the Supabase session, not just the cached profile in localStorage,
  // so an expired session redirects to sign-in instead of failing queries.
  let loggedIn = false;
  try {
    loggedIn = await authService.hasActiveSession();
  } catch {
    loggedIn = false;
  }

  if (!loggedIn) {
    return router.createUrlTree(['/sign-in']);
  }

  // User is logged in: check license validity
  let valid = false;
  try {
    valid = await licenseService.isValid();
  } catch {
    valid = false;
  }

  if (!valid) {
    // Keep the user logged in but show the license-expired page
    return router.createUrlTree(['/license-expired']);
  }

  const userRole = authService.getUserRole();

  // If the user is an annotator, redirect them to the report summary when trying to access dashboard
  if ((userRole === Roles.ANNOTATOR || userRole === Roles.REVIEWER) && (state.url.includes('/dashboard') || state.url.includes('/status-dashboard'))) {
    return router.createUrlTree(['/reports/summary']);
  }

  // If the user is an admin, redirect them to the system users page when trying to access report summary
  if (userRole === Roles.ADMIN && state.url.includes('/reports/summary')) {
    return router.createUrlTree(['/reports/all-reports']);
  }

  return true;
};
